import { CascadiaStandardIcon } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";

import { ButtonGroup, GhostIconButton } from "@certn/cascadia-react";

import { NavigationBar } from "./NavigationBar";
import { Text } from "../../../foundations/typography/Text";
interface titleRow {
  title?: string;
  subtitle?: string;
  tag?: React.ReactNode;
}

interface SecondaryNavProps {
  testID: string;
  children?: React.ReactNode;
  leftIcon: CascadiaStandardIcon;
  onleftIconOnPress: () => void;
  titleArea?: titleRow;
}

export function SecondaryTopNav(props: SecondaryNavProps) {
  const { testID, children, leftIcon, onleftIconOnPress, titleArea } = props;

  return (
    <NavigationBar testID={props.testID}>
      <GhostIconButton
        icon={leftIcon}
        size="medium"
        testID={`${testID}-${leftIcon}`}
        onPress={onleftIconOnPress}
      />
      {titleArea && (
        <div className={styles.userInfo}>
          <div>
            <Text
              style="global/heading-medium"
              color="text-base"
              testID="case-details-secondary-top-nav-client-account-name"
            >
              {titleArea.title}
            </Text>
          </div>
          <div className={styles.titleRow}>
            {titleArea.tag && titleArea.tag}
            <Text
              style="global/heading-small"
              color="text-weak"
              testID="case-details-secondary-top-nav-case-id"
            >
              {titleArea.subtitle}
            </Text>
          </div>
        </div>
      )}
      <ButtonGroup justify="end">{children}</ButtonGroup>
    </NavigationBar>
  );
}

const styles = {
  userInfo: css({
    display: "flex",
    padding: "var(--space-0)",
    flexDirection: "column",
    alignItems: "flex-start",
  }),
  titleRow: css({
    display: "flex",
    gap: "var(--space-1)",
    alignItems: "center",
  }),
};
